import {
  OTHER_EXCLUSION_AREA_TYPE_ID,
  toTypeId,
  type ExclusionAreaFeature,
} from './exclusionAreaTypeResolution'

// Exclusion areas are displayed and deduplicated by `otherName || name`, so a rename that left
// `otherName` behind would keep showing (and flagging) the previous name. Type "Otro" is the
// exception: AreaRow gives it a dedicated "Otro nombre" field that owns the value.
export const renameExclusionArea = (
  exclusionAreas: ExclusionAreaFeature[] | null | undefined,
  featureId: string,
  newName: string,
): ExclusionAreaFeature[] =>
  (exclusionAreas || []).map(exclusionArea => {
    if (exclusionArea.properties.id !== featureId) {
      return exclusionArea
    }

    const ownsOtherName =
      toTypeId(exclusionArea.properties.exclusionAreaTypeId) === OTHER_EXCLUSION_AREA_TYPE_ID

    return {
      ...exclusionArea,
      properties: {
        ...exclusionArea.properties,
        name: newName,
        otherName: ownsOtherName ? exclusionArea.properties.otherName : newName,
      },
    }
  })
